import {ChangeDetectionStrategy, Component, Input, OnInit} from "@angular/core";

require('./chat-user-avatar.scss');
@Component({
  standalone: false,
  selector: 'chat-user-avatar',
  templateUrl: './chat-user-avatar.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatUserAvatarComponent implements OnInit {

  @Input() url: string;
  @Input() name?: string;
  @Input() isSmall?: boolean;
  @Input() count?: boolean;
  @Input() color?: any;

  constructor() {}

  ngOnInit(): void {}
}
